// extracted by mini-css-extract-plugin
module.exports = {"cardProblemSidePadding":"64px"};